import Swiper from 'swiper/bundle';

class ProductCardSlider {
  constructor(elem) {
    this._elem = elem;
    this._target = this._elem.dataset.productCardSlider;
    this._swiperSettings = {
      autoplay: false,
      cache: false,
      loop: true,
      navigation: {
        nextEl: `.css-swiper-button-next span`,
        prevEl: `.css-swiper-button-prev span`
      }
    };
    this._swiperInstance = null;
  }

  _initializeSwiper(settings) {
    this._swiperInstance = new Swiper(`.product-card-slider--${this._target}`, settings);
  }

  onResize() {
    if (this._swiperInstance) {
      this._swiperInstance.destroy(true, true);
    }    
    this._initializeSwiper(this._swiperSettings);
  }

  onInit() {    
    this._initializeSwiper(this._swiperSettings);
    window.addEventListener('resize', this.onResize.bind(this));
  }
}

export default ProductCardSlider;
